<template>
  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
        <b-row>
          <!-- first name -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="descrição"
              rules="required"
            >
              <b-form-group
                label="Descrição"
                label-for="v-description"
              >
                <b-form-input
                  id="v-description"
                  v-model="civilStatusPlace.nome"
                  :state="errors.length > 0 ? false : null"
                  placeholder="descrição"
                  :disabled="!canEditOrInsert"
                  data-cy="description-input"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            v-if="civilStatusPlace.id"
            cols="12"
          >
            <b-form-group>
              <b-form-checkbox
                v-model="civilStatusPlace.ativo"
                :checked="civilStatusPlace.ativo"
                name="check-button"
                switch
                inline
                :disabled="!canEditOrInsert"
                data-cy="active-checkbox"
              >
                {{ civilStatusPlace.ativo ? 'Sim' : 'Não' }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <!-- submit and reset -->
          <ButtonsFormVue
            :permission-insert="canInsert"
            :permission-edit="canEdit"
            :disable-form="false"
            @save="save()"
            @cancel="cancel()"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import mixinsGlobal from '@/mixins'
import { verificarPermissao } from '@/auth/utils'
import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue'

export default {
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('civilStatusSettingsModule', {
      civilStatus: state => state.civilStatus,
    }),
    canInsert() {
      return verificarPermissao('ROLE_ESTADO_CIVIL_INSERIR')
    },
    canEdit() {
      return verificarPermissao('ROLE_ESTADO_CIVIL_ATUALIZAR')
    },
    canEditOrInsert() {
      return (
        (!this.civilStatusPlace.id && this.canInsert)
        || (this.civilStatusPlace.id && this.canEdit)
      )
    },
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    ButtonsFormVue,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      titleForm: 'Cadastro de Estado Civil',
      required,
      civilStatusPlace: {
        nome: '',
        ativo: true,
      },
    }
  },
  mounted() {
    this.civilStatusPlace = JSON.parse(JSON.stringify(this.civilStatus))
  },
  methods: {
    cancel() {
      this.$emit('cancelar')
      this.cleanObjeto()
      this.$store.dispatch('civilStatusSettingsModule/resetCivilStatus')
    },
    save() {
      this.$refs.form.validate().then(success => {
        if (success) {
          if (this.civilStatusPlace.id) {
            this.$store
              .dispatch(
                'civilStatusSettingsModule/editCivilStatus',
                this.civilStatusPlace,
              )
              .then(response => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Editar',
                    response.response.data.error,
                  )
                  return
                }
                this.showMessageSuccess('Editar', 'Editado com sucesso!')
                this.$refs.form.reset()
                this.cancel()
              })
          } else {
            this.$store
              .dispatch(
                'civilStatusSettingsModule/insertNewCivilStatus',
                this.civilStatusPlace,
              )
              .then(response => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Inserir',
                    response.response.data.error,
                  )
                  return
                }
                this.showMessageSuccess('Salvo', 'Incluido com sucesso!')
                this.cleanObjeto()
                this.$refs.form.reset()
              })
          }
        }
      })
    },
    cleanObjeto() {
      this.civilStatusPlace = {
        nome: '',
        ativo: true,
      }
    },
  },
}
</script>
